module.exports = __webpack_public_path__ + "img/offing_wave_point.2a733a7b.svg";